import { ShowMore } from "@/molecules/ShowMore"
import { ActionCard } from "@/organisms/Drawers/components/TriageDrawer/components/ActionsCard"

import styles from "./TriageActionCell.module.scss"

import type { Issue, Ticket } from "@/domain/issue"
import type { TicketingSystem } from "@/domain/ticketing"
import type { TFunction } from "@/hooks/useTranslation"

export const TriageIssueActionCell = (t: TFunction) =>
  function TriageIssueActionCellComponent(
    tickets: Ticket[],
    record: Issue & { ticketSystems?: TicketingSystem[] }
  ) {
    const hasTickets = tickets && tickets.length > 0
    const hasPullRequests =
      record.pullRequests && record.pullRequests.length > 0
    const hasAction = hasTickets || hasPullRequests

    if (!hasAction) return null

    return (
      <ShowMore
        id={`actions_${record.id}`}
        label={
          <div className={styles.label}>
            <ShowMore.Label.Component>
              <ActionCard.Label
                hasTicketAction={hasTickets}
                hasPullRequestAction={hasPullRequests}
                ticketSystems={record.ticketSystems}
              />
            </ShowMore.Label.Component>
          </div>
        }
      >
        <ShowMore.Component title={t("general.actions")}>
          <ActionCard.List
            tickets={tickets}
            pullRequests={record.pullRequests}
            type={"secondary"}
          />
        </ShowMore.Component>
      </ShowMore>
    )
  }
